/* eslint-disable */

// Polyfill for Object.entries
if (!Object.entries) {
  Object.entries = function (obj) {
    const ownProps = Object.keys(obj);
    const ownValues = Object.values(obj);
    let i = ownProps.length;
    const resArray = new Array(i); // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], ownValues[i]];

    return resArray;
  };
}

// Polyfill for Number.isFinite
if (Number.isFinite === undefined) Number.isFinite = function(value) {
  return typeof value === 'number' && isFinite(value);
}
